import React, {useMemo, useState, useEffect, useCallback} from 'react';
import {isEmpty, last} from 'lodash';
import {useField} from 'react-final-form';
import FiltersArray from 'dashboards/components/filters/FiltersArray';
import {makeFilter} from '../simpleExpression/utils';

const EMPTY_ARRAY = [];

const FiltersField = ({isEditable, isApplyMode}: {isEditable: boolean, isApplyMode: boolean}) => {
  const {
    input: {value: formValue, onChange: onChangeForm},
  } = useField('filters');

  const [localValue, onChangeLocalValue] = useState(formValue);

  useEffect(() => {
    onChangeLocalValue(formValue);
  }, [formValue]);

  const value = isApplyMode ? localValue : formValue;
  const onChange = useCallback(
    (changedValue, isCheckbox) => {
      if (isApplyMode && isCheckbox) {
        onChangeLocalValue(changedValue);
      } else {
        onChangeForm(changedValue);
      }
    },
    [isApplyMode],
  );

  const valueWithEmpty = useMemo(
    () => ((isEmpty(last(value)) && value.length) || !isEditable ? value : value.concat([[]])),
    [value, isEditable],
  );

  const appliedValueWithEmpty = useMemo(
    () => ((isEmpty(last(formValue)) && formValue.length) || !isEditable ? formValue : formValue.concat([[]])),
    [formValue, isEditable],
  );

  const onApply = useCallback(() => onChangeForm(localValue), [localValue]);
  const onBlur = useCallback(() => onChangeLocalValue(formValue), [formValue]);

  return (
    <FiltersArray
      isApplyMode={isApplyMode}
      isEditable={isEditable}
      filter={makeFilter(value, true)}
      value={valueWithEmpty || EMPTY_ARRAY}
      onChange={onChange}
      onApply={isApplyMode ? onApply : undefined}
      onBlur={onBlur}
      appliedValue={appliedValueWithEmpty || EMPTY_ARRAY}
    />
  );
};

export default FiltersField;
